import { render, staticRenderFns } from "./MonthlySettlement.vue?vue&type=template&id=bd468a50&scoped=true"
import script from "./MonthlySettlement.vue?vue&type=script&lang=js"
export * from "./MonthlySettlement.vue?vue&type=script&lang=js"
import style0 from "./MonthlySettlement.vue?vue&type=style&index=0&id=bd468a50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd468a50",
  null
  
)

export default component.exports